/* RESPONSIBLE TEAM: team-workflows */

import StepSerializer from '../step';

export default StepSerializer;
